import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box, Stack } from '@mui/material';
import { Text } from '@telegram-apps/telegram-ui';
import { type FC } from 'react';
import { RitualConfig } from '../../helpers/ritual';
import { CommonIcon } from '../common/CommonIcon';

interface RatingHeaderBannerProps {
    config: RitualConfig;
    taskName?: string | null;
}

export const RatingHeaderBanner: FC<RatingHeaderBannerProps> = ({ config, taskName }) => {
    return (
        <Box sx={{ margin: '16px', borderRadius: '16px', overflow: 'hidden', ...liquidGlassRowShadowSx }}>
            <Box sx={{ borderRadius: 'inherit', padding: '16px', ...liquidGlassSurfaceFillSx }}>
                <Stack direction="row" alignItems="center" gap={1.5}>
                    <Box
                        sx={{
                            width: 44,
                            height: 44,
                            flexShrink: 0,
                            borderRadius: '12px',
                            background: config.iconBg,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <CommonIcon
                            icon={config.icon}
                            type="outlined"
                            size={22}
                            color="var(--tg-theme-button-text-color)"
                        />
                    </Box>
                    <Stack direction="column" gap={0.25}>
                        <Text style={{ fontSize: '18px', fontWeight: 600, color: 'var(--tg-theme-text-color)' }}>
                            {taskName}
                        </Text>
                        <Text style={{ fontSize: '13px', color: 'var(--tg-theme-hint-color)' }}>
                            {config.title}
                        </Text>
                    </Stack>
                </Stack>
            </Box>
        </Box>
    );
};
